import React, { useState, useEffect, useContext, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { Collapse } from 'antd';

const DotplotChart = (props) => {
    const { Panel } = Collapse;

    let dotplotData = props.getAnalysisRes.dotplot;

    const dp = dotplotData.values;
    const dpOutliers = dotplotData.outliers;

    let dotplotDisplayName = props.getAnalysisRes.display_name;

    let dotplotOptions = {
        credits: {
            enabled: false
        },
        chart: {
            type: 'scatter',
            zoomType: 'xy',
            height: 400,
            chartWidth: '100%'
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            visible: false,
            min: -30,
            max: 30,
            title: {
                enabled: true
                // text: 'Height (cm)'
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true
        },
        yAxis: {
            title: {
                text: dotplotDisplayName
            }
        },

        plotOptions: {
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    // pointFormat: '{point.x} cm, {point.y} kg'
                    pointFormat: '{point.y}'
                }
            }
        },
        series: [
            {
                name: dotplotDisplayName,
                color: 'rgba(64, 124, 177, .5)',
                // color: 'rgba(96, 9, 29, .5)',
                data: dp
            },
            {
                name: 'Outliers',
                // color: 'rgba(64, 124, 177, .5)',
                color: 'rgba(96, 9, 29, .5)',
                data: dpOutliers
            }
        ]
    };

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Dotplot ${props.getAnalysisRes.filter_by_variable == null ? '': `[${props.getAnalysisRes.filter_by_variable}]`}`}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={dotplotOptions}
                        ref={props.forwardedRef}
                    />
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(DotplotChart);
